import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '@/components/SectionHeading';
import { useInView } from '@/lib/hooks';

const INDUSTRIES = [
  'Restaurants', 'Cafés', 'Boutiques', 'Salons',
  'Architects', 'Coaches', 'Clinics', 'Retail Stores',
];

export default function Industries() {
  const [ref, inView] = useInView({ threshold: 0.2, once: true });
  return (
    <section className="section pt-16 md:pt-20 bg-[color:var(--sh-surface-2)]/40" data-testid="industries-block">
      <div className="container-pro">
        <SectionHeading
          eyebrow="WHO IT’S FOR"
          title="Built for every kind of business."
          subtitle="From hot kitchens to clean studios — if you serve customers, we serve you."
        />
        <div ref={ref} className="flex flex-wrap justify-center gap-2.5">
          {INDUSTRIES.map((tag, i) => (
            <motion.span
              key={tag}
              initial={{ opacity: 0, y: 8 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.35, delay: i * 0.04 }}
              className="inline-flex items-center px-4 py-2 rounded-full border border-[color:var(--sh-line)] bg-white text-[color:var(--sh-ink-soft)] text-[13px] font-medium hover:border-[color:var(--sh-amber)] hover:text-[color:var(--sh-amber-2)] hover:bg-[#FFFCF4] transition-colors cursor-default"
            >
              {tag}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
